import React from 'react'

const NoMatch = () => (
  <div className='flex-c h-margin'>
    <h3 className='h-margin'>Error: 404 - Page Not Found</h3>
  </div>
)

export default NoMatch